import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { ButtonBase } from "@mui/material";

const DelayedLink = ({ children, delay, href, ...props }) => {
  const router = useRouter();

  const handleDelayedClick = (e) => {
    e.preventDefault();
    setTimeout(() => router.push(href), delay);
  };

  return (
    <Link href={href} passHref>
      <ButtonBase onClick={handleDelayedClick} {...props}>
        {children}
      </ButtonBase>
    </Link>
  );
};

DelayedLink.defaultProps = {
  delay: 250,
};

export default DelayedLink;
